import React, { useContext } from 'react'
import styled from 'styled-components'
import { useLocation, useParams } from 'react-router-dom'
import { SmallText } from '../styles/texts'
import dividerImg from '../assets/breadcrumb-divider.svg'
import { parseActionName } from '../utils/general-utils'
import EnvironmentContext from '../context/EnvironmentContext'
import { EnvironmentsDictionary } from '../constants/environmentsDictionary'

const Breadcrumbs = () => {
  const location = useLocation()
  const params = useParams()
  const environment = useContext(EnvironmentContext)

  const pathnames = location.pathname.split('/').filter((x) => x)
  const showName =
    environment?.data?.namespace &&
    parseActionName(environment?.data?.namespace)
  return (
    <BreadcrumbsSection>
      {pathnames.map((name, index) => {
        if (name === params.id) {
          return (
            <span key={index}>
              <SmallText>
                {EnvironmentsDictionary[params.id]?.name ||
                  (environment?.data?.namespace &&
                    parseActionName(environment?.data?.namespace))}
              </SmallText>
            </span>
          )
        } else {
          return (
            <span key={index}>
              <Divider src={dividerImg} alt=">" />
              <SmallText>{name && parseActionName(name)}</SmallText>
            </span>
          )
        }
      })}
    </BreadcrumbsSection>
  )
}

const BreadcrumbsSection = styled.div`
  display: flex;
  align-items: center;
  @media only screen and (max-width: 700px) {
    flex-wrap: wrap;
  }
  span {
    display: flex;
    align-items: center;
  }
  p {
    color: #a7acc1;
  }
`

const Divider = styled.img`
  padding: 0 4px;
`

export default Breadcrumbs
